import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FaRedo, FaShareAlt, FaThumbtack, FaTrashAlt } from 'react-icons/fa';
import { MdForwardToInbox, MdReply, MdReplyAll } from 'react-icons/md';
import { CanCreate, CanDelete, CanUpdate } from '@/shared/components/security';
import FormattedDateShort from '@/shared/components/FormattedDateShort';
import intlShape from '@/shared/utils/intlShape';
import FileIcon from '@/shared/components/FileIcon';
import RelationName from '@/shared/components/RelationName';
import Checkbox from '@/shared/components/input/Checkbox';
import FormattedDateTime from '@/shared/components/FormattedDateTime';
import messages from './documentMessages';

function getIndexOfElement(str, char, n) {
  return str
    .split(char)
    .slice(0, n)
    .join(char).length;
}

function formatEmailAddresses(addresses) {
  const addressCount = addresses.split(';').length;
  let formattedAddresses = addresses.slice(0, getIndexOfElement(addresses, ';', 3));
  if (addressCount > 3) {
    formattedAddresses = `${formattedAddresses} (+${addressCount - 3})`;
  }
  return formattedAddresses;
}

export default class EmailRow extends React.Component {
  render() {
    const {
      email,
      onOpenDocumentDetails,
      intl,
      handleSelection,
      onDeleteDocument,
      onCreateTodo,
      onShareItem,
      onDeleteRelation,
      onForward,
      onResend,
      onReplyTo,
      columnStatus,
    } = this.props;
    return (
      <tbody className="hover">
        <tr onDoubleClick={() => onOpenDocumentDetails(email)} key={email.id}>
          <td className="">
            <Checkbox onClick={() => handleSelection(email)} value={email.selected} />
          </td>
          <td>
            <FileIcon document={email} />
            <span className="text-clickable" onClick={() => onOpenDocumentDetails(email)}>
              {email.subject}
            </span>
          </td>
          <td
            // this avoids the relation name from being clipped over the next column
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {email.relations &&
              email.relations.slice(0, 3).map(relation => (
                <span className="margin10R" key={relation.id}>
                  <RelationName
                    key={relation.id}
                    relation={relation}
                    onDeleteRelation={
                      email.canRemove ? relationId => onDeleteRelation(relationId) : null
                    }
                  />
                </span>
              ))}
            {email.relations && email.relations.length > 3 && (
              <span
                title={intl.formatMessage(messages.NrOfLinkedRelations, {
                  nr: email.relations.length,
                })}
              >
                &hellip;
              </span>
            )}
          </td>
          <td>{email.sender}</td>
          <td>{email.recipients && formatEmailAddresses(email.recipients)}</td>{' '}
          {columnStatus.referenceYear && (
            <td className="fw-normal">{email.referenceYear || null}</td>
          )}
          <td className="text-nowrap">
            <FormattedDateShort value={email.documentDate} />
          </td>
          <td className="text-nowrap">
            <FormattedDateTime value={email.creationDate} />
          </td>
          <td className="actions-column text-nowrap">
            <a
              className="btn btn-xs btn-icon"
              title={intl.formatMessage(messages.Reply)}
              onClick={() => onReplyTo(email, false)}
            >
              <MdReply />
            </a>
            <a
              className="btn btn-xs btn-icon"
              title={intl.formatMessage(messages.ReplyAll)}
              onClick={() => onReplyTo(email, true)}
            >
              <MdReplyAll />
            </a>
            <a
              className="btn btn-xs btn-icon"
              title={intl.formatMessage(messages.Forward)}
              onClick={() => onForward(email)}
            >
              <MdForwardToInbox />
            </a>
            <CanUpdate on="Documents">
              <a
                className={classNames('btn btn-xs btn-icon', {
                  disabled: email.documentType !== 8,
                })}
                title={
                  email.documentType === 8
                    ? intl.formatMessage(messages.ResendEmail)
                    : intl.formatMessage(messages.OnlyEmailsByAdminPulseCanBeResent)
                }
                onClick={() => email.documentType === 8 && onResend(email)}
              >
                <FaRedo />
              </a>
            </CanUpdate>
            <a
              className="btn btn-xs btn-icon"
              title={intl.formatMessage(messages.Share)}
              onClick={() => onShareItem(email)}
            >
              <FaShareAlt />
            </a>
            <CanCreate on="Todo">
              <a
                className="btn btn-xs btn-icon"
                title={intl.formatMessage(messages.CreateNewToDo)}
                onClick={() => onCreateTodo(email)}
              >
                <FaThumbtack />
              </a>
            </CanCreate>
            <CanDelete on="Documents">
              <a
                className={classNames('btn btn-xs btn-icon', {
                  disabled: !email.canRemove,
                })}
                title={
                  email.canRemove
                    ? intl.formatMessage(messages.Delete)
                    : intl.formatMessage(messages.SystemEmailsCannotBeRemoved)
                }
                onClick={() => email.canRemove && onDeleteDocument(email)}
              >
                <FaTrashAlt />
              </a>
            </CanDelete>
          </td>
        </tr>
      </tbody>
    );
  }
}

EmailRow.propTypes = {
  email: PropTypes.shape({}).isRequired,
  intl: intlShape.isRequired,
  onOpenDocumentDetails: PropTypes.func.isRequired,
  handleSelection: PropTypes.func.isRequired,
  onDeleteDocument: PropTypes.func.isRequired,
  onCreateTodo: PropTypes.func.isRequired,
  onShareItem: PropTypes.func.isRequired,
  onDeleteRelation: PropTypes.func.isRequired,
  onForward: PropTypes.func.isRequired,
  onResend: PropTypes.func.isRequired,
  columnStatus: PropTypes.shape({}),
};

EmailRow.defaultProps = {
  columnStatus: {},
};
